import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const KeyboardUtil = require("../../util/keyboard");

const propTypes = {
    id: PropTypes.string.isRequired,
    openIdProviders: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired
    })).isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedOpId: PropTypes.string,
    listClassName: PropTypes.string,
    labelText: PropTypes.string,
    dropDown: PropTypes.bool,
};

const defaultProps = {
    selectedOpId: "-1",
    listClassName: "op-selector",
};

class OpenIdProviderSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOpId: !!props.selectedOpId ? parseInt(props.selectedOpId, 10) : "",
        };

        this._makeSelection = this._makeSelection.bind(this);
        this.onSelectableClick = this.onSelectableClick.bind(this);
        this.onSelectableKeyDown = this.onSelectableKeyDown.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
        this.onSelectOpId = this.onSelectOpId.bind(this);
    }

    _makeSelection=(id)=>{
        if (!this.props.onSelect) {
            return;
        }

        this.props.onSelect(id);
    }

    onSelectableClick=(id, e)=>{
        e.stopPropagation();
        this._makeSelection(id);
    }

    onSelectableKeyDown=(id, e)=>{
        e.stopPropagation();

        if (KeyboardUtil.isSelectKey(e.keyCode)) {
            this._makeSelection(id);
        }
    }

    stopPropagation=(e)=>{
        e.stopPropagation();
    }
    
    onSelectOpId=(e)=>{
        this.setState({ selectedOpId: e.target.value }, () => {
            this._makeSelection(e.target.value);
        });
    }

    render() {
        if (!this.props.openIdProviders) {
            return null;
        }

        if (this.props.dropDown) {
            return (
                <Form.Group controlId="formControlSelectOpenIdProvider">
                    <Form.Label>{this.props.labelText}</Form.Label>
                    <Form.Control
                        as="select"
                        placeholder="-1"
                        value={this.state.selectedOpId}
                        onChange={this.onSelectOpId}
                    >
                            <option value="-1" key="placeholder">{(this.props.openIdProviders && this.props.openIdProviders.length) > 0 ? 'Select a provider...' : 'None'}</option>
                            {this.props.openIdProviders.map((op) =>
                                <option value={op.id} key={op.id}>{`${op.iss} ${op.description || ''}`}</option>
                            )}
                  </Form.Control>
                </Form.Group>
            );
        }
        return (
            <div className="op-selector">
                <label>{this.props.labelText}</label>
                <ul id={this.props.id}>
                    {this.props.openIdProviders.map((op) => {
                        const selected = (!!this.props.selectedOpId && parseInt(this.props.selectedOpId, 10) === op.id);
                        return (
                            <li
                                key={op.id}
                                className={selected ? "selected" : ""}
                                aria-checked={!!this.props.selectedOpId && parseInt(this.props.selectedOpId, 10) === op.id}
                                tabIndex="0"
                                onClick={this.onSelectableClick.bind(this, op.id)}
                                onKeyDown={this.onSelectableKeyDown.bind(this, op.id)}
                            >
                                <span className="op-id">{op.id}</span>
                                <span className="iss">{op.iss}</span>
                                <span className="description">{op.description}</span>
                            </li>
                        );  
                    })}
                </ul>
            </div>
        );
    }
}

OpenIdProviderSelector.propTypes = propTypes;
OpenIdProviderSelector.defaultProps = defaultProps;

export default OpenIdProviderSelector;